export enum UserSeverityStatus {
    None = 0,
    Mild = 1,
    Moderate = 2,
    Advanced = 3
} 

